const Remediation = () => <div>Remediation Page</div>;

export default Remediation;
